const adminUserSharedConstantsEn = {
  newPasswordRule1: 'Password must be at least 8 character',
  newPasswordRule2: 'Password must have at least one uppercase and one lowercase letter',
  newPasswordRule3: 'Password must have at least one number',
  newPasswordRule4: 'Password must have at least one special character',
  invalidPassword: 'Password does not meet the criteria below',
  invalidConfirmPassword: 'Passwords do not match',
  invalidEmail: 'Please enter a valid email address',
  emailUsed: 'Email address already in use',
  emptyPassword: 'Please enter your password',
  emptyConfirmPassword: 'Please confirm your password',
  emptyEmail: 'Please enter your email',
  emptyFirstName: 'Please enter your first name',
  emptyLastName: 'Please enter your last name',
  emptyUserRole: 'Please select a user role',
  invalidOldPasswordNewPassword: 'Old password and new password cannot be the same',
  adminUserPermissionEdit: 'Edit',
  adminUserPermissionDelete: 'Delete',
  adminUserPermissionView: 'View',
};

export default adminUserSharedConstantsEn;
